import { type InputValidationState } from '@landsbankinn/ui-kit';
import { useCallback, useMemo, useReducer } from 'react';
import {
  useApplicationServerContext,
  type LoginServerState,
} from 'src/state/server';

export function useSmsValidation() {
  const [serverState] = useApplicationServerContext() as [LoginServerState];
  // pattern regex
  const regex = useMemo(
    () => new RegExp(serverState.forms.sms.fields.code.pattern as string),
    [serverState.forms.sms.fields.code.pattern],
  );
  type State = {
    code: {
      value: string;
      validationState?: InputValidationState;
    };
  };
  type Action = {
    type: 'on change code';
    value: string;
    validationState: InputValidationState;
  };

  const [state, dispatch] = useReducer(
    function formReducer(formState: State, action: Action): State {
      switch (action.type) {
        case 'on change code': {
          return {
            ...formState,
            code: {
              value: action.value,
              validationState: action.validationState,
            },
          };
        }
        default:
          return formState;
      }
    },
    {
      code: {
        value: '',
        validationState: 'unset',
      },
    },
  );

  const validateCode = useCallback(
    function validate(code?: string | undefined): InputValidationState {
      if (code !== undefined && code !== '') {
        if (regex.test(`${code}`)) {
          return 'valid';
        } else {
          return 'invalid';
        }
      } else {
        return 'unset';
      }
    },
    [regex],
  );

  const onCodeChanged = useCallback(
    function onCodeChanged(value: string) {
      const validationState = validateCode(value);
      // dispatch for the actual input
      dispatch({
        type: 'on change code',
        value: value,
        validationState: validationState,
      });
    },
    [validateCode],
  );

  return {
    onCodeChanged,
    smsState: state,
  };
}
